module.exports = __webpack_public_path__ + "static/media/arrows-with-fluctuations.019e6104.svg";